package com.anjuros.website.redesign.sections.trades

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.components.rdFaqJsonLd
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL

/** JSON-LD for the Trades page: the service, the breadcrumb and the FAQ. */
@Composable
fun tradesStructuredData(): String {
    val name = LocalText(RdText.TRADES_HERO_TITLE_START) + LocalText(RdText.TRADES_HERO_TITLE_MARK)
    val breadcrumb = rdBreadcrumbJsonLd(RdText.TRADES_CRUMB, RdRoute.TRADES)
    val faq = rdFaqJsonLd(TradesFaqs)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"Service","name":${jsonString(name)},"serviceType":"Website design","areaServed":"GB",
          "url":"$SITE_URL${RdRoute.TRADES}","provider":{"@id":"$SITE_URL/#business"},
          "audience":{"@type":"BusinessAudience","name":"UK sole traders and local businesses"}},
         $breadcrumb,
         $faq
        ]}
    """.trimIndent()
}
